/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from "react";
import { Category } from "../interfaces/intefaces";
import { routes } from "../router/Routes";
import { useLocation, useNavigate } from "react-router-dom";
import Icon from "./Icon";
import {
    AllGamesIcon,
    BaccaratIcon,
    BlackjackIcon,
    FavoritesIcon,
    FeatureBuyIcon,
    LiveCasinoIcon,
    LobbyIcon,
    LottoIcon,
    NewGamesIcon,
    OthercasinoIcon,
    OtherGamesIcon,
    PokerIcon,
    RouletteIcon,
    ScratchCardsIcon,
    TableGamesIcon,
    TopPicksIcon,
    VideoSlotsIcon,
    VirtualGames,
    RecommendedIcon,
} from "./Icons";
import { useTranslation } from "../hooks/hooks";
import { useAtom } from "jotai";
import { activeProvidersAtom, userIsLoggedInAtom } from "../state/games";
import { getCategoryIcon, scrollToTop } from "../helpers/helpers";
import { Box, Tab, Tabs } from "@mui/material";
declare const initCallback: () => void;

interface IProps {
    categories: Category[];
    activeCategory: number;
    updateCategory: (category_id: number) => void;
    setCategoryType: (categoryType: number) => void;
}

const MobileCategories: React.FC<IProps> = ({
    categories,
    activeCategory,
    updateCategory,
    setCategoryType,
}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { _e } = useTranslation();

    const [, setActiveProviders] = useAtom(activeProvidersAtom);
    const [userIsLoggedIn] = useAtom(userIsLoggedInAtom);
    const [value, setValue] = React.useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };
    useEffect(() => {
        initCallback();
    }, []);

    const tabStyles = {
        color: "#fff",
        textTransform: "none",
        fontSize: "14px",
        fontWeight: "600",
        svg: {
            width: "24px",
            height: "24px",
            marginRight: "5px",
        },
    };
    return (
        <Box
            sx={{
                backgroundColor: "#0f1432",
                margin: "25px -10px 0",
                "@media (min-width:992px)": {
                    display: "none",
                },
            }}
        >
            <Tabs
                variant="scrollable"
                scrollButtons="auto"
                aria-label="categories"
                value={value}
                onChange={handleChange}
                allowScrollButtonsMobile={false}
                visibleScrollbar={true}
                sx={{
                    ".MuiTabs-scroller": {
                        padding: "0 10px",
                        ".MuiTabs-indicator": {
                            display: "none",
                        },
                    },

                    ".MuiTab-root": {
                        fontFamily: "quasimoda, sans-serif",
                        minHeight: "0",
                        margin: "15px 0",
                        "&.Mui-selected": {
                            borderRadius: "25px",
                            backgroundColor: "#1a2355",
                            color: "#fff",
                        },
                    },
                }}
            >
                <Tab
                    sx={tabStyles}
                    label={_e("Lobby")}
                    onClick={() => {
                        scrollToTop();
                        setActiveProviders([]);
                        updateCategory(0);
                        navigate(routes.root);
                    }}
                    icon={<Icon icon={LobbyIcon} />}
                    iconPosition="start"
                />

                <Tab
                    sx={tabStyles}
                    label={_e("Favourites")}
                    onClick={() => {
                        if (userIsLoggedIn) {
                            scrollToTop();
                            setActiveProviders([]);
                            updateCategory(0);
                            navigate(routes.pages.favorites);
                        }
                    }}
                    icon={<Icon icon={FavoritesIcon} />}
                    iconPosition="start"
                />
                <Tab
                    sx={tabStyles}
                    label={_e("Recommended")}
                    onClick={() => {
                        scrollToTop();
                        setActiveProviders([]);
                        updateCategory(0);
                        navigate(routes.pages.hot);
                    }}
                    icon={<Icon icon={RecommendedIcon} />}
                    iconPosition="start"
                />

                {categories.map(category => {
                    return (
                        <Tab
                            key={`key-${category.id}`}
                            sx={tabStyles}
                            label={category.name}
                            onClick={() => {
                                scrollToTop();
                                setActiveProviders([]);
                                updateCategory(category.id);
                                setCategoryType(category.type);
                                navigate(`${routes.pages.games}/${category.slug}`);
                            }}
                            icon={<Icon icon={getCategoryIcon(category.slug)} />}
                            iconPosition="start"
                        />
                    );
                })}
            </Tabs>
        </Box>
    );
};

export default MobileCategories;
